<template>
    <div class="fm_module" v-if="!!params.list && params.list.length>0">
        <div class="media-title" v-if="params.title_box">
            <div class="title-txt">
                {{params.title}}
            </div>
            <div class="title-more" @click="onClick(params.link)" v-if="0">
                {{params.more}}
            </div>
        </div>
        <div class="media-content">
            <div class="content-li"   >
                <div class="content-img">
                    <van-image
                      @click="onClick(params.link)"
                      width="100%"
                      height="100%"
                      fit="cover"
                      :src="params.img"
                      radius="5"
                    />

                    <div class="content-bottom">
                      <div class="content-info-view">
                        {{params.play_count}}人观看
                      </div>
                      <div class="content-info-op">
                        <span class="iconfont iconicon_play"></span>
                        <span class="play_all" @click="playAll(params)" >播放全部</span>
                      </div>
                    </div>
                    
                </div>
                <div class="content">
                  <div v-for="(item,index) in params.list" :key="index" class="sections" @click="playSection(params,item)">
                    <div class="sections_play" :class="{sections_active:item.active}">
                      <span v-if="item.active" class="iconfont iconyinpinpianduan"></span>
                      <span v-else class="iconfont iconicon_play"></span>
                    </div>
                    <div class="sections_name" :class="{sections_active:item.active}">{{item.sections_name}}</div>
                    <div class="sections_duration" :class="{sections_active:item.active}">{{item.mates_duration_cn}}</div>
                  </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Image as VanImage } from 'vant';
    
    export default {
        name: "fm_module",
        props:{
            params:Object
        },
        data(){
            return {
              current_sections_id:''
            }
        },
        created() {  
          this.$EventBus.$on('player_switch_play2', target => {
              console.warn("player_switch_play2",target)
              this.onSwitch_play(target)
          });
          this.$EventBus.$on('player_close', target => {
              console.warn("player_close",target)
              this.player_close(target)
          });
        },
        components:{
            [VanImage.name]:VanImage
        },
        methods: {
            playAll(params){
              console.log('play')
              if(params.is_own !=1){
                this.bindOrderCourse(params.course_id)
              }
              this.$EventBus.$emit("start_play", {
                'course_id':params.course_id,
                'sections_id':'',
                'cover':params.img,
                'show_wyplayer': true,
              });
            },
            playSection(params,item){
              if(params.is_own !=1){
                this.bindOrderCourse(params.course_id)
              }
              this.$EventBus.$emit("start_play", {
                'course_id':params.course_id,
                'sections_id':item.sections_id,
                'cover':params.img,
                'show_wyplayer': true,
              });
            },
            onClick(link) {
                // console.log(link)
                // this.util.carouselUrl(link);
                if(this.current_sections_id){
                  link = link+'&sections_id='+this.current_sections_id
                }
                this.$router.push(link);
            },
            onSwitch_play(target){
              this.current_sections_id = target.sections_id
              console.log('onSwitch_play')
              this.params.list.forEach(element => {
                if(element.sections_id == target.sections_id){
                    element.active = true
                }else{
                    element.active = false
                }
              });
            },
            player_close(target){
              console.log('player_close')
              this.params.list.forEach(element => {
                element.active = false
              });
            },
            bindOrderCourse(course_id){
              this.util.server.mini_pay.order_course({
                  data: {
                      type: 1,
                      course_id: course_id,
                      pay_money: 0,
                      coupon_user_id: '',
                      sum_money: 0,
                      coupon_money: 0

                  },
                  callback: (res => {
                      if(res.code == 1){
                          //location.reload();
                      }
                  })
              })
          },
        },
    }
</script>

<style scoped>
    .fm_module{
        width: 100%;
        /*margin-top: 10px;*/
        margin: 10px 0;
    }
    .fm_module .media-title{
        background-color: #fff;
    }
    .fm_module .media-title .title-txt,.fm_module .media-title .title-more{
        display: inline-block;
        vertical-align: middle;
    }
    .fm_module .media-title .title-txt{
        max-width: 80%;
        font-size: 16px;
        font-weight: bold;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        color: #171717;
    }
    .fm_module .media-title .title-more{
        float: right;
        color: #327CE9;
        font-size: 12px;
        margin-top: 2px;
    }
    .fm_module .media-content{
        width: 100%;
        background-color: #fff;
        flex-wrap: wrap;
    }
    .fm_module .media-content .content-li{
        padding: 10px 0;
        box-sizing: border-box;

    }
    .fm_module .content-li .content-img{
        position: relative;
        font-size: 0;
        height: 198px;
    }
    .fm_module .content-bottom{
      position: absolute;
      bottom: 10px;
      display: flex;
      justify-content: space-between;
      width: 100%;
      padding: 0px 10px;
      box-sizing: border-box;
    }
    .fm_module .content-img .content-info-view{
        font-size: 12px;
        color: #ffffff;;
        height: 27px;
        line-height: 27px;
        padding: 0px 8px;
        background: rgb(0, 0, 0,0.57);
        border-radius: 13px;
    }
    .fm_module .content-info-op{
        font-size: 12px;
        color: #ffffff;;
        height: 27px;
        line-height: 27px;
        padding: 0px 8px;
        background: rgb(0, 0, 0,0.57);
        border-radius: 3px;
    }
    .fm_module .content-info-view .iconfont{
        font-size: 10px;
    }

    .content-info-op .iconicon_play{
      font-size: 11px;
    }
    .content-info-op .play_all{
      margin-left: 2px;
    }
    .fm_module .sections{
      display: flex;
      height: 25px;
      justify-content: space-between;
      align-items: center;
    }
    .fm_module .sections_duration{
      width: 60px;
      font-size: 11px;
      text-align: right;
    }
    .sections_play{
      width: 20px;
    }
    .sections_play .iconicon_play{
      font-size: 14px;
    }
    .sections_play .iconyinpinpianduan{
      font-size: 15px;
    }
    .sections_name{
      flex: 1;
      text-align: left;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      font-size: 14px;
      color: #616161;
    }
    .sections_active{
      color: rgba(255, 103, 2, 1) !important;
    }


    .fm_module .content-li .content-title{
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        font-weight: bold;
    }
    .fm_module .content-li .content-info-play-time{
        font-size: 12px;
    }
    .fm_module .content-info-type{
        position: absolute;
        top: 0;
        right: 0;
        margin: 3px;
        padding: 2px 6px;
        font-size: 10px;
        color: #ffffff;
        background: rgba(0,0,0,0.4);
        border-radius: 5px;
    }
    .fm_module .content-lecturer{
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        color: #999999;
        margin: 4px 0;
        font-size: 12px;
    }
    .fm_module .content{
        box-shadow: 1px 7px 10px #eee;
        min-height: 35px;
        padding: 8px;
        border-radius: 0 0 5px 5px;
    }
    .fm_module .content-li .content-info-play-time{
        font-size: 12px;
        color: #999999;
        flex: 1;
    }
    .fm_module .content-info{
        display: flex;
        line-height: 16px;
    }
    .fm_module .content-info-play-money{
        font-size: 12px;
        color: #FF624F;
    }
</style>
